import { render } from "./RoundedButton.vue?vue&type=template&id=6ee9795c&scoped=true"
const script = {}

import "./RoundedButton.vue?vue&type=style&index=0&id=6ee9795c&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee9795c"]])

export default __exports__